import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DELIVERED_AT_TO: (time: string, location: string, isDelivered: boolean) =>
        `${isDelivered ? "Levert" : "Leveres"} ${time}, til ${location}`,
      DATE_FORMAT: "dd. MMM yyyy",
      DETAILED_OVERVIEW: "Detaljert oversikt",
    },

    se: {
      DELIVERED_AT_TO: (time: string, location: string, isDelivered: boolean) =>
        `${isDelivered ? "Levererade" : "Levereras"} ${time}, till ${location}`,
      DATE_FORMAT: "dd MMM yyyy",
      DETAILED_OVERVIEW: "Detaljerad översikt",
    },

    dk: {
      DELIVERED_AT_TO: (time: string, location: string, isDelivered: boolean) =>
        `${isDelivered ? "Leveret" : "Afleveres"} ${time}, til ${location}`,
      DATE_FORMAT: "dd. MMM yyyy",
      DETAILED_OVERVIEW: "Detaljeret oversigt",
    },
  } as const
)[language];
